import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../../../core/config';

@Injectable()
export class EtloutsideInfoService {
  private url: string = 'http://localhost:8080/api/v1/geohosting';



  constructor(private http: HttpClient, private config: ConfigService) {
    this.url = this.config.getConfig('xtpc.geohc').url || this.url;
  }

  getEtloutsideInfoEndTime(): Observable<JSON> {
    const connectUrl = this.url + '/ETLoutsideInfo'
    return this.http.get<JSON>(connectUrl)
  }

}
